module.exports = __webpack_public_path__ + "img/cruise-cover-placeholder.3c32b34.png";